'use client';
import { WHATSAPP_NUMBER } from '@/constants';
import { FC } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useCleverTap } from '@/context/clevertapContext';
import { useUser } from '@/context/userContext';

const WhatsappFooter: FC = () => {
  const headerClass =
    'text-lg font-semibold hover:underline cursor-pointer group-hover:underline';
  const pathname = usePathname();
  const { pushEvent } = useCleverTap();
  const { userDetails } = useUser();

  const dataToTrack = {
    Name: userDetails?.firstname
      ? `${userDetails?.firstname} ${userDetails?.lastname}`
      : 'Guest User',
    'Mobile Number': userDetails?.mobilenumber ?? 'NA',
    Email: userDetails?.email ?? 'NA',
    From: 'Footer Link',
    Path: pathname === '/' ? 'Home' : pathname,
    'Logged In': userDetails?.id ? 'Yes' : 'No',
  };

  function handleWhatsappClick() {
    pushEvent({
      event: 'Whatsapp Interaction',
      data: dataToTrack,
    });
    window.open(
      `https://api.whatsapp.com/send?phone=91${WHATSAPP_NUMBER}&text=Hi&utm_source=Whatsapp&utm_medium=Clevetap&utm_campaign=Whatsapp_icon_web&utm_term=030624`,
      '_blank'
    );
  }

  return (
    <button
      className='group flex basis-1/4 items-center max-[375px]:w-full'
      onClick={handleWhatsappClick}>
      <div className='block aspect-square h-10 rounded-full border-2 border-white bg-transparent text-center'>
        <div className='flex h-full items-center justify-center'>
          <Image
            src={'/vectors/whatsapp.svg'}
            alt='Whatsapp'
            width={16}
            height={16}
          />
        </div>
      </div>
      <div className='ml-3 flex flex-col'>
        <p className={headerClass}>WhatsApp Us</p>
        {/* <p className={subHeaderClass}>{WHATSAPP_NUMBER}</p> */}
      </div>
    </button>
  );
};

export default WhatsappFooter;
